import React, { useRef, useState } from "react"
import { Form, Input, Toast } from "antd-mobile"
import { Button } from 'antd'
//加载必须要的core，demo简化起见采用的直接加载类库，实际使用时应当采用异步按需加载
import Recorder from "recorder-core"
import "recorder-core/src/extensions/wavesurfer.view"
//需要使用到的音频格式编码引擎的js文件统统加载进来，这些引擎文件会比较大
import "recorder-core/src/engine/pcm"
import { AudioFill, AudioOutline, EditSOutline, PlayOutline } from "antd-mobile-icons"
import { blobToBase64, formatTime } from "@/utils"
import produce from "immer"
import FUIcon from "../../../Common/FUIcon"
import { useEffect } from "react"
import { useCallback } from "react"
import { useImperativeHandle } from "react"
import { PlayCircleFilled } from "@ant-design/icons"

const ToastContent = (props) => {
    const { recordStatus } = props
    const [recordingTime, setRecordingTime] = useState(0)
    const recordIntervalRef = useRef<any>(0)
    const recordingTimeRef = useRef(0)
    useEffect(() => {

        recordIntervalRef.current = setInterval(() => {
            recordingTimeRef.current++
            setRecordingTime(recordingTimeRef.current)
        }, 1000)
        return () => {
            setRecordingTime(0)
            clearInterval(recordIntervalRef.current)
            recordIntervalRef.current = null
        }
    }, [])
    return <>
        <div className="recording-time">
            {recordingTime}S
        </div>
        <div className="send-dialog">
            <FUIcon
                size="72pt"
                name={
                    recordStatus === 'recording'
                        ? 'slices/icon_popup_voice@3x.png'
                        : recordStatus === 'cancel'
                            ? 'slices/icon_popup_cancel send@3x.png'
                            : 'slices/icon_popup_abnormal@3x.png'
                }
            />
            {recordStatus === 'recording' && (
                <div>
                    <p>松开发送，上滑取消</p>
                    <p>{formatTime(recordingTime)}</p>
                </div>
            )}
            {recordStatus === 'cancel' && (
                <p>松开手指，取消发送</p>
            )}
            {recordStatus === 'error' && (
                <p>说话时间太短</p>
            )}
        </div>
    </>
}

const MessageComp = React.forwardRef((props: any, ref) => {
    const { emitByText, emitByAudio, logs, setLogs, interrupt } = props

    const [mode, setMode] = useState('text')
    const [msgtext, setMsgtext] = useState('')
    const switchMode = () => {
        setMode(mode === "audio" ? "text" : "audio")
    }

    const sendMsg = () => {
        if (!msgtext) return
        emitByText(msgtext, true)
        setMsgtext('')
    }
    // 申请录音权限，ios部分浏览器需要在手机设置中给浏览器开通权限
    const recRef = useRef<any>(null)
    const startPosYRef = useRef(0)
    const [recordStatus, setRecordStatus] = useState('')
    const [isRecordDialogShow, setIsRecordDialogShow] = useState(false)
    const dialogIntRef = useRef<any>('')
    const recOpen = (event) => {
        // 打开弹窗
        setRecordStatus("recording")
        setIsRecordDialogShow(true)
        if (event.touches) {
            var touch = event.touches[0] //touches数组对象获得屏幕上所有的touch，取第一个touch
            startPosYRef.current = touch.pageY
        }
    }

    const showDialog = () => {
        //我们可以选择性的弹一个对话框：为了防止移动端浏览器存在第三种情况：用户忽略，并且（或者国产系统UC系）浏览器没有任何回调
        if (!/mobile/i.test(navigator.userAgent)) {
            return //只在移动端开启没有权限请求的检测
        }
    }
    const dialogCancel = () => {
        clearTimeout(dialogIntRef.current)
    }

    const recordMove = (event) => {
        if (event.touches.length > 1 || (event.scale && event.scale !== 1))
            return
        var touch = event.touches[0]
        if (startPosYRef.current - touch.pageY > 80) {
            setRecordStatus("cancel")
        }
        if (
            startPosYRef.current - touch.pageY <= 80 &&
            recordStatus === "cancel"
        ) {
            setRecordStatus("recording")
        }
    }

    const recordEnd = () => {
        // 上滑取消
        if (recordStatus === "cancel") {
            recRef.current.stop()
            setIsRecordDialogShow(false)
        }
        // 正常发送
        if (!(recRef.current && Recorder.IsOpen())) {
            setIsRecordDialogShow(false)
            Toast.show({ content: "请在系统设置中打开浏览器的麦克风权限" })
            return
        }
        recRef.current.stop(
            async (blob, duration) => {
                // 时间过短
                if (duration <= 1000) {
                    setRecordStatus("error")
                    setTimeout(() => {
                        setIsRecordDialogShow(false)
                    }, 1000)
                } else {
                    setRecordStatus('')
                    recRef.current.blob = blob
                    const base64data = await blobToBase64(blob)
                    emitByAudio(base64data)
                    setIsRecordDialogShow(false)
                }
            },
            (s) => {
                setIsRecordDialogShow(false)
                console.log("录音失败：" + s, 1)
            }
        )
    }
    const recordCancel = () => {
        recRef.current.stop()
        setRecordStatus('')
    }
    const recordLog = (target, msg) => {
        console.log('msg', msg)
        logs.push({
            target,
            msg,
            id: +new Date() + target,
            timestamp: +new Date(),
        })
        setLogs([...logs])
    }
    useImperativeHandle(ref, () => {
        return {
            recordLog
        }
    })

    useEffect(() => {
        if (recordStatus === 'recording') {
            const waveView = new Recorder.WaveSurferView({
                width: '200',
                height: '30',
                elem: '.wave'
            })
            recRef.current = Recorder({
                type: 'pcm',
                bitRate: 16,
                sampleRate: 16000,
                onProcess: function (buffers, powerLevel, bufferDuration, bufferSampleRate, newBufferIdx) {
                    waveView.input(buffers[newBufferIdx], powerLevel, bufferSampleRate)
                }
            })
            dialogIntRef.current = setTimeout(function () {
                //定时8秒后打开弹窗，用于监测浏览器没有发起权限请求的情况
                showDialog()
            }, 8000)
            recRef.current.open(
                () => {
                    dialogCancel()
                    if (!recRef.current || !Recorder.IsOpen()) {
                        // reclog("未打开录音", 1)
                        return
                    }
                    recRef.current.start()
                    // wave = Recorder.WaveView({ elem: ".ctrlProcessWave" })
                },
                (msg, isUserNotAllow) => {
                    dialogCancel()
                    console.log(
                        (isUserNotAllow ? "UserNotAllow，" : "") +
                        "打开失败：" +
                        msg,
                        1
                    )
                }
            )
        }
    }, [recordStatus])

    return (
        <>
            <div className="message-comp">
                <div
                    className="text-comp"
                >
                    {
                        mode === 'audio' ? (
                            <>
                                {
                                    recordStatus !== 'recording' ? (
                                        <div
                                            className="audio-btn"
                                        >
                                            <FUIcon
                                                name="slices/icon_talk_play.svg"
                                                size="20px"
                                                onClick={recOpen}
                                            />
                                            <div style={{
                                                width: 'calc(100% - 36px)',
                                                color: 'rgba(19, 17, 85, .25)'
                                            }}>点击左侧图标开始录音</div>
                                        </div>
                                    ) : (
                                        <div
                                            className="audio-btn"
                                        >
                                            <FUIcon
                                                name="slices/icon_talk_delete.svg"
                                                size="20px"
                                                onClick={recordCancel}
                                            />
                                            <div
                                                className="wave"
                                                style={{
                                                    width: 'calc(100% - 36px)',
                                                    height: '52px',
                                                    paddingRight: '6px'
                                                }}
                                            ></div>
                                        </div>
                                    )
                                }
                            </>
                        ) : (
                            <Input
                                value={msgtext}
                                placeholder='请输入文字'
                                className='text-input'
                                onChange={setMsgtext}
                                onKeyDown={(e) => {
                                    if (e.keyCode === 13) {
                                        sendMsg()
                                    }
                                }}
                            />
                        )
                    }
                    {
                        recordStatus === 'recording' && (
                            <ToastContent />
                        )
                    }
                    <div
                        className="mode-btn"
                        onClick={switchMode}
                    >
                        {mode === 'text'
                            ? <FUIcon
                                name="slices/icon_talk_voice.svg"
                                size="20px"
                                onClick={switchMode}
                            />
                            : <FUIcon
                                name="slices/icon_talk_voice_active.svg"
                                size="20px"
                                onClick={switchMode}
                            />
                        }
                    </div>
                </div>
                <div
                    className={(msgtext || recordStatus === 'recording') ? 'send-btn active' : "send-btn"}
                    onClick={recordStatus === 'recording' ? recordEnd : sendMsg}
                >
                    <FUIcon
                        name={(msgtext || recordStatus === 'recording')
                            ? "slices/icon_send_active.png"
                            : "slices/icon_send_disable.png"
                        }
                    />
                </div>
            </div >
            <div className="message-comp-mobile">
                <Button
                    className="mode-btn"
                    onClick={switchMode}
                >
                    {mode === 'text' ? <AudioOutline fontSize={'16px'} /> : <EditSOutline fontSize={'16px'} />}
                </Button>
                <div
                    className="text-comp"
                    style={{ display: mode === 'text' ? '' : 'none' }}
                >
                    <Input
                        value={msgtext}
                        placeholder='请输入文字'
                        className='text-input'
                        onChange={setMsgtext}
                        onKeyDown={(e) => {
                            if (e.keyCode === 13) {
                                sendMsg()
                            }
                        }}
                    />
                    <Button className="send-btn" onClick={sendMsg}>发送</Button>
                </div>

                <button
                    className="audio-btn"
                    style={{ display: mode === 'audio' ? 'block' : 'none' }}
                    onTouchStart={recOpen}
                    onTouchEnd={recordEnd}
                    onTouchMove={recordMove}
                >
                    按住说话
                </button>
                {isRecordDialogShow && (
                    <ToastContent recordStatus={recordStatus} />
                )}
            </div >
        </>

    )
})

export default MessageComp
